<template>
  <div>
    <v-stepper class="v-stepper__customized" v-model="subStage">
      <v-stepper-header>
        <v-stepper-step
          :step="item"
          v-for="item in totalSteps"
          :key="`step__${item}`"
          complete-icon="mdi-check"
          :complete="item < subStage"
        ></v-stepper-step>
      </v-stepper-header>
    </v-stepper>

    <template v-for="item in totalSteps">
      <div :key="`slot_${item}`">
        <slot :name="`step_${item}`" v-if="subStage === item"></slot>
      </div>
    </template>
    <template v-if="subStage > totalSteps">
      <slot name="finalScreen"></slot>
    </template>
  </div>
</template>

<script>
export default {
  name: 'generateStage',
  props: {
    subStage: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    totalSteps() {
      return Object.keys(this.$slots).filter((item) => item.includes('step_'))
        .length
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/_ai_works';
</style>
